export default __webpack_public_path__ + "static/media/payment.18588cb5.png";